export function preventDefault(enabled = true) {
  return !enabled ? () => void 0 : (e: Event) => e.preventDefault()
}
